import { Modal, Form } from "react-bootstrap";
import ModalHead from "../../../../common/ui/ModalHead";
import ErrorAlert from "../../../../common/ui/ErrorAlert";

/* ⚠ id="txtAuthMobile" and name="authmobile" are read by handleChangeMobileFields
   off the event's name. Renaming either stops the field updating state. */
export default function MobileModalPage(props) {
    const formData = props.loyaltyMember.MobileModalPage;
    return (
        <>
            <ModalHead title="Sign in" />
            <Modal.Body className="wo-loy__body">
                <div className="wo-loy__intro">
                    <h3 className="wo-loy__head">What&rsquo;s your mobile number?</h3>
                    <p className="wo-loy__sub">
                        We&rsquo;ll text you a code. Use the number your rewards account is under.
                    </p>
                </div>

                <div className="wo-loy__form">
                    <Form.Floating>
                        <Form.Control type="tel" id="txtAuthMobile" name="authmobile" placeholder="Mobile" className={formData.Fields.authmobile.HasError ? "is-invalid" : ""} value={formData.Fields.authmobile.Value} onChange={props.handleChangeMobileFields} maxLength={formData.Fields.authmobile.MaxLength} disabled={formData.GeneralError.ButtonsDisabled}></Form.Control>
                        <Form.Control.Feedback type="invalid">{formData.Fields.authmobile.ErrorMessage}</Form.Control.Feedback>
                        <label htmlFor="txtAuthMobile">Mobile</label>
                    </Form.Floating>

                    { formData.GeneralError.HasError && <ErrorAlert message={formData.GeneralError.ErrorMessage} /> }

                    <button type="button" className="wo-btn wo-btn--primary" onClick={props.handleNextValidateMobile} disabled={formData.GeneralError.ButtonsDisabled}>
                        Send me a code
                        { formData.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                    </button>

                    <div className="wo-loy__or"><span>or</span></div>

                    <button type="button" className="wo-btn wo-btn--ghost" onClick={props.handleClickCloseLoyaltyModal} disabled={formData.GeneralError.ButtonsDisabled}>Continue as guest</button>
                </div>
            </Modal.Body>
        </>
    )
}
